/*
 * The Chart Room — existing-client gate for the Year Reading and the
 * 30-Day Q&A Window.
 *
 * WHY THIS FILE EXISTS AT ALL
 * Dawn renders the product form with `novalidate`, so the `required` attribute
 * on the gate input is inert: the browser will not block the submit and will not
 * show its own message. Dawn's <product-form> then intercepts submit itself and
 * POSTs to /cart/add. So the gate has to be enforced in script, and it has to be
 * enforced BEFORE <product-form> sees the event.
 *
 * HOW THE ORDERING IS GUARANTEED
 * <product-form> binds its handler to the form element itself. A listener bound
 * to the form — capture or not — would run in registration order against it,
 * which is a race we would lose or win by accident. So this listener is bound to
 * `document` in the CAPTURE phase: capture descends document -> ... -> form, so
 * it always runs first, and stopImmediatePropagation() there stops the event
 * before it ever reaches the form's own listeners. That holds no matter what
 * order the scripts load in.
 *
 * WHAT SUBMITS
 * Nothing here touches the payload. The input lives inside {% form 'product' %}
 * with name="properties[Original Life Chart order]", and Dawn builds its request
 * body with `new FormData(this.form)` — so once this file lets the submit
 * through, the property is serialised with the rest of the form and lands on the
 * line item. That is the whole mechanism; this file only decides whether the
 * submit is allowed to happen.
 */
(function () {
  if (window.__crGatedAddonBound) return;
  window.__crGatedAddonBound = true;

  var GATE = '[data-cr-gate]';
  var INPUT = '[data-cr-gate-input]';
  var ERROR = '[data-cr-gate-error]';

  function firstEmptyGate(form) {
    var gates = form.querySelectorAll(GATE);
    for (var i = 0; i < gates.length; i++) {
      var input = gates[i].querySelector(INPUT);
      if (input && !input.value.trim()) return gates[i];
    }
    return null;
  }

  function showError(gate) {
    var input = gate.querySelector(INPUT);
    var error = gate.querySelector(ERROR);
    gate.classList.add('cr-gate--invalid');
    if (error) error.hidden = false;
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      // focus() after the paint so the message is already in the a11y tree.
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  function clearError(gate) {
    var input = gate.querySelector(INPUT);
    var error = gate.querySelector(ERROR);
    gate.classList.remove('cr-gate--invalid');
    if (error) error.hidden = true;
    if (input) input.removeAttribute('aria-invalid');
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

      var gate = firstEmptyGate(form);
      if (!gate) return;

      event.preventDefault();
      // Stops Dawn's <product-form> handler, which is bound to the form itself.
      event.stopImmediatePropagation();
      showError(gate);
    },
    true
  );

  // Clear the message as soon as they start typing — an error that persists
  // while the field is being fixed reads as broken rather than strict.
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(INPUT)) return;
    var gate = input.closest(GATE);
    if (gate && input.value.trim()) clearError(gate);
  });
})();
